export const COMPLEXITY = 'duration';
export const FEATURED = 'featured';
export const MAX_END_TIME = 'max_end_time';
export const MAX_ENTRY_CAP = 'max_cap_entries';
export const MAX_FEE = 'max_fee';
export const MAX_PRIZE = 'max_prize';
export const MAX_START_TIME = 'max_start_time';
export const MIN_END_TIME = 'min_end_time';
export const MIN_ENTRY_CAP = 'min_cap_entries';
export const MIN_FEE = 'min_fee';
export const MIN_PRIZE = 'min_prize';
export const MIN_START_TIME = 'min_start_time';
export const PAYOUT = 'payout';
export const PLAYERS = 'players';
